import React, { useState } from "react";
import axios from "axios";

const useWebsiteBasicInformation = ({
  onFinish = ({ axiosMode, status, values }) => {},
  onBefore = ({ axiosMode, status }) => {},
}) => {
  const [data, setData] = useState([]);
  const [communityData, setCommunityData] = useState([]);
  const getWebsiteBasicInformationData = (params) => {
    onBefore({
      axiosMode: "get",
    });
    return axios
      .get("/dynamicWebsite/frontend/information", {
        params: params,
      })
      .then((response) => {
        let data = response.data;
        setData(data?.data);
        if (data) {
          onFinish({
            axiosMode: "get",
            status: "success",
          });
        } else {
          onFinish({
            axiosMode: "get",
            status: "error",
          });
        }

        return {
          ...data,
        };
      });
  };
  const postWebsiteBasicInformationData = (data) => {
    onBefore({
      axiosMode: "post",
    });
    axios
      .post("/dynamicWebsite/backend/information", data)
      .then((response) => {
        let responseData = response.data;
        let status = responseData?.status;
        if (status === "failure") {
          onFinish({
            axiosMode: "post",
            status: "error",
          });
        } else {
          onFinish({
            axiosMode: "post",
            status: "success",
          });
        }
      })
      .catch(() => {
        onFinish({
          axiosMode: "post",
          status: "error",
        });
      });
  };
  const patchWebsiteBasicInformationData = (data) => {
    onBefore({
      axiosMode: "patch",
    });
    axios
      .patch("/dynamicWebsite/backend/information", data)
      .then((response) => {
        let responseData = response.data;
        let status = responseData?.status;
        if (status === "failure") {
          onFinish({
            axiosMode: "patch",
            status: "error",
          });
        } else {
          onFinish({
            axiosMode: "patch",
            status: "success",
          });
        }
      })
      .catch(() => {
        onFinish({
          axiosMode: "patch",
          status: "error",
        });
      });
  };
  const deleteWebsiteBasicInformationData = (data) => {
    onBefore({
      axiosMode: "delete",
    });
    axios
      .delete("/dynamicWebsite/backend/information", {
        data,
      })
      .then((response) => {
        let responseData = response.data;
        let status = responseData?.status;
        if (status === "failure") {
          onFinish({
            axiosMode: "delete",
            status: "error",
          });
        } else {
          onFinish({
            axiosMode: "delete",
            status: "success",
          });
        }
      })
      .catch(() => {
        onFinish({
          axiosMode: "delete",
          status: "error",
        });
      });
  };

  const patchWebsiteBasicInformationClickData = (data) => {
    onBefore({
      axiosMode: "patch",
    });
    return axios
      .patch("/dynamicWebsite/frontend/information/click", data)
      .then((response) => {
        // let responseData = response.data;
        // let status = responseData?.status;
        // if (status === "failure") {
        //   onFinish({
        //     axiosMode: "patch",
        //     status: "error",
        //   });
        // } else {
        //   onFinish({
        //     axiosMode: "patch",
        //     status: "success",
        //   });
        // }
      })
      .catch(() => {
        onFinish({
          axiosMode: "patch",
          status: "error",
        });
      });
  };

  const getCommunityData = (params) => {
    onBefore({
      axiosMode: "get",
    });
    return axios
      .get("/dynamicWebsite/backend/community", {
        params: params,
      })
      .then((response) => {
        let data = response.data;
        setCommunityData(data?.data);
        if (data) {
          onFinish({
            axiosMode: "get",
            status: "success",
          });
        } else {
          onFinish({
            axiosMode: "get",
            status: "error",
          });
        }

        return {
          ...data,
        };
      });
  };
  return {
    WebsiteBasicInformationData: data,
    getWebsiteBasicInformationData,
    postWebsiteBasicInformationData,
    patchWebsiteBasicInformationData,
    deleteWebsiteBasicInformationData,
    patchWebsiteBasicInformationClickData,
    communityData: communityData,
    getCommunityData,
  };
};
export { useWebsiteBasicInformation };
